import React, { PureComponent } from 'react';
import b from 'b_';

import './project-item.css';

import { Project } from '@interfaces/outreach-entity';
import { formatDate } from 'client/helpers/date';

const class_ = b.with('project-item');

interface Props {
    entity: Project;
    type: 'horizontal' | 'vertical';
}

export default class ProjectItem extends PureComponent<Props> {
    public render() {
        const { entity, type } = this.props;
        const { image, title, date, description, link } = entity;
        const imageUrl = image || '/no-record.png';

        let imageBlock = (
            <div
                className={class_('image')}
                style={{ backgroundImage: `url(${imageUrl})` }}
            />
        );

        // В списках показываем полное изображение с фиксированной шириной
        if (type === 'horizontal') {
            imageBlock = (
                <img className={class_('image')} src={imageUrl} />
            );
        }

        return (
            <div className={class_({ type })}>
                <a className={class_('image-wrap')} href={link}>{imageBlock}</a>
                <div className={class_('info')}>
                    <a className={class_('title')} href={link}>
                        {title}
                    </a>

                    {type === 'horizontal' && (
                        <div className={class_('description')}>
                            {description}
                        </div>
                    )}

                    <div className={class_('date')}>
                        {formatDate(date)}
                    </div>
                </div>
            </div>
        );
    }
}
